/**
 * App-wide constants and domain enums (mirrors the Strapi backend).
 */

// --- Auth / cookies ---
export const TOKEN_COOKIE_KEY = "token";

export const TOKEN_COOKIE_CONFIG = {
  // Secure cookies are dropped on http://localhost, so only enable in prod.
  secure: import.meta.env.PROD,
  sameSite: "strict",
  expires: 7, // days
};

// --- Domain enums (keep in sync with backend schemas) ---
export const SECTIONS = {
  PK_FASHION: "pk_fashion",
  NA_PRODUCTS: "na_products",
  BOTH: "both",
};

export const SECTION_LABELS = {
  [SECTIONS.PK_FASHION]: "PK Fashion",
  [SECTIONS.NA_PRODUCTS]: "NA Products",
  [SECTIONS.BOTH]: "Both",
};

/** Human label for any enum value: under_score -> "Under score". */
export const humanize = (value) =>
  typeof value === "string"
    ? value.replaceAll("_", " ").replace(/^\w/, (c) => c.toUpperCase())
    : value;

export const ORDER_STATUS = {
  RECEIVED: "received",
  UNDER_REVIEW: "under_review",
  QUOTATION_SENT: "quotation_sent",
  PAYMENT_PENDING: "payment_pending",
  PAYMENT_RECEIVED: "payment_received",
  PROCESSING: "processing",
  IN_PRODUCTION: "in_production",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  COMPLETED: "completed",
};

export const CUSTOM_ORDER_STATUS = {
  MEASUREMENTS_RECEIVED: "measurements_received",
  DESIGN_CONFIRMED: "design_confirmed",
  PRODUCTION_STARTED: "production_started",
  QUALITY_CHECK: "quality_check",
  READY_FOR_DISPATCH: "ready_for_dispatch",
};

export const QUOTE_STATUS = {
  PENDING: "pending",
  SENT: "sent",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EXPIRED: "expired",
};
